import { render } from "./order_payments_report.vue?vue&type=template&id=72d3ac58&scoped=true"
import script from "./order_payments_report.vue?vue&type=script&lang=js"
export * from "./order_payments_report.vue?vue&type=script&lang=js"

import "./order_payments_report.vue?vue&type=style&index=0&id=72d3ac58&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d3ac58"]])

export default __exports__